import { FASSUNG } from "../fassung";
import { useT } from "../i18n";

/**
 * Version und Zweig, in einer Zeile: `V26.09.16 · pre-production`.
 *
 * Steht an zwei Stellen — in der Anmeldung und unten in der Leiste, dort
 * aber nur, solange die Einstellungen offen sind. Luca, 16.09.2026: *„damit man sehen kann"*, auf welcher
 * Fassung und welchem Zweig man gerade ist. Mit `stand` kommt der Commit
 * dazu; sonst steht er im Titel und erscheint beim Verweilen.
 */
export function Fassung({ stand = false, className }: { stand?: boolean; className?: string }) {
  const t = useT();
  const unbekannt = t("app.fassungUnbekannt");
  const version = FASSUNG.version ?? unbekannt;
  const zweig = FASSUNG.zweig ?? unbekannt;
  const sha = FASSUNG.sha ?? unbekannt;
  const trenn = ` ${t("allgemein.trennpunkt")} `;
  return (
    <span
      className={className ? `fassung ${className}` : "fassung"}
      title={t("app.fassungTitel", { version, zweig, sha })}
    >
      {version}{trenn}{zweig}{stand ? `${trenn}${sha}` : null}
    </span>
  );
}
